import { flowsListQuery } from '../../../../api-v2/queries/flows-list-query';
import {
  taskGroupQuery,
  taskGroupsListQuery,
} from '../../../../api-v2/queries/task-groups-list-query';

export const flowGroupsPageLoader = (queryClient) => () => {
  queryClient.ensureQueryData(taskGroupsListQuery());

  return {};
};

export const editFlowGroupPageLoader = (queryClient) => async (opts) => {
  const { flowGroupId } = opts.params;
  await queryClient.ensureQueryData(taskGroupQuery({ flowGroupId }));
  await queryClient.ensureQueryData(flowsListQuery());

  return { flowGroupId };
};
